import React from 'react';
import { ArrowDownIcon } from 'lucide-react';
export function Hero() {
  const scrollToContent = () => {
    const contentElement = document.getElementById('content');
    if (contentElement) {
      contentElement.scrollIntoView({
        behavior: 'smooth'
      });
    }
  };
  return <section className="relative overflow-hidden text-white" data-id="element-100">
      {/* Base background gradient that covers the entire section */}
      <div className="absolute inset-0 bg-gradient-to-r from-[#0096B4] to-[#7DCCD8] z-0" data-id="element-101"></div>
      {/* Background decorative elements */}
      <div className="absolute top-0 left-0 w-full h-full overflow-hidden z-0" data-id="element-102">
        <div className="absolute top-20 left-10 w-64 h-64 rounded-full bg-[#E0F5F8] opacity-20 blur-3xl" data-id="element-103"></div>
        <div className="absolute bottom-10 right-20 w-80 h-80 rounded-full bg-[#E0F5F8] opacity-20 blur-3xl" data-id="element-104"></div>
        <div className="absolute top-40 right-40 w-40 h-40 rounded-full bg-[#E0F5F8] opacity-10 blur-xl" data-id="element-105"></div>
      </div>
      {/* Desktop image with ombre effect - hidden on mobile/tablet */}
      <div className="hidden lg:block absolute inset-0 z-5" data-id="element-106">
        <div className="absolute inset-0 bg-gradient-to-r from-[#0096B4] to-transparent z-5" data-id="element-107"></div>
        <img src="https://uploadthingy.s3.us-west-1.amazonaws.com/4n1qhRzwz139JLt3wz4gsW/Untitled_design_%282%29.png" alt="Katalina Bock" className="absolute right-0 h-full w-auto object-cover object-right" style={{
        filter: 'drop-shadow(0 4px 20px rgba(0,0,0,0.15))',
        maxHeight: '130%',
        maxWidth: 'none'
      }} data-id="element-108" />
      </div>
      {/* Content container */}
      <div className="container mx-auto px-4 py-20 md:py-24 relative z-10" data-id="element-109">
        <div className="max-w-4xl" data-id="element-110">
          <h1 className="text-4xl md:text-5xl font-bold mb-4 text-white" data-id="element-111">
            Product Leader
            <span className="text-[#E0F5F8]" data-id="element-112">
              {' '}
              Sparking Growth & Innovation
            </span>
          </h1>
          <p className="text-xl mb-8 text-white opacity-90 max-w-3xl" data-id="element-113">
            Helping companies win the hearts of customers by building products
            that thrive — driving adoption, loyalty, and multimillion-dollar
            growth.
          </p>
          <div className="flex flex-wrap gap-4" data-id="element-114">
            <a href="#case-studies" className="bg-white hover:bg-[#E0F5F8] text-[#0096B4] px-6 py-3 rounded-md font-medium transition-colors duration-200 shadow-md hover:shadow-lg" data-id="element-115">
              View My Work
            </a>
            <a href="/contact" className="bg-transparent border border-white hover:bg-white/10 text-white px-6 py-3 rounded-md font-medium transition-colors duration-200 shadow-sm hover:shadow-md" data-id="element-116">
              Get In Touch
            </a>
          </div>
        </div>
      </div>
      {/* Scroll down button */}
      <div className="absolute bottom-5 left-1/2 transform -translate-x-1/2 cursor-pointer animate-bounce z-20" data-id="element-117">
        <button onClick={scrollToContent} aria-label="Scroll down" className="bg-white bg-opacity-80 rounded-full p-2 hover:bg-opacity-100 transition-all duration-200 shadow-md" data-id="element-118">
          <ArrowDownIcon size={24} className="text-[#0096B4]" data-id="element-119" />
        </button>
      </div>
    </section>;
}